import { render, staticRenderFns } from "./StallionSettings.vue?vue&type=template&id=2a0091ff&"
import script from "./StallionSettings.vue?vue&type=script&lang=js&"
export * from "./StallionSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports